import { grayPaletteDark } from '../../themes/dark-colors';
import { opacity } from '../../utils';

export const modalDarkV2Theme = {
  footer: {
    backgroundColor: grayPaletteDark[100],
  },
  overlay: {
    backgroundColor: opacity(grayPaletteDark[400], 50),
  },
};
